exports.Piece = {
    EMPTY : 0,
    PAWN_WHITE : 1,
    PAWN_BLACK : 2,
    DAME_WHITE : 3,
    DAME_BLACK : 4
};

exports.Color = {
    NONE : 0,
    WHITE : 1,
    BLACK : 2
};

exports.DraughtsTypes8x8 = {
    
    NONE : 0,
    BRAZILIAN : 1,
    RUSSIAN : 2,
    ITALIAN : 3,
    CHECKERS : 4,
    TURKISH : 5,
    convertFromDAP : function(type) {
        switch (type) {
            case '1' : return this.BRAZILIAN;
            case '2' : return this.RUSSIAN;
            case '3' : return this.CHECKERS;
            case '4' : return this.ITALIAN;
        }
        return this.NONE;
    }
};





// WEBPACK FOOTER //
// ./src/board/utils/symbols.js